export default __webpack_public_path__ + "static/media/wordmark-light.e98555bb.png";